<template>
  <v-dialog
    v-model="show"
    scrollable
    :overlay="true"
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title class="body-1">
        {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.CANCEL_FINE') }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="close()">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-form v-model="formValid">
          <v-container>
            <v-row class="d-flex align-center">
              <!-- Comments -->
              <v-col cols="12" sm="12">
                <v-textarea
                  v-model="comments"
                  :label="$vuetify.lang.t('$vuetify.COMMENTS')"
                  outlined
                  autofocus
                  required
                  :rules="commentRules"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary" class="secondary--text"
          text
          :disabled="!formValid"
          @click="cancelFine()"
        >
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CancelParkingFineDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    parkingFine: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formValid: false,
      comments: '',
      commentRules: [
        v =>
          v.length >= 2 ||
          this.$vuetify.lang.t('$vuetify.ENFORCEMENT.COMMENTS_REQUIRED')
      ]
    }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    ...mapGetters('app', ['loading'])
  },
  watch: {
    formValid() {
      this.$emit(this.formValid ? 'valid' : 'invalid')
    }
  },
  methods: {
    ...mapActions('enforcement', ['putParkingFine']),
    cancelFine() {
      this.close()
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(option => {
        if (option === true) {
          this.putParkingFine({
            id: this.parkingFine.id,
            status: 'VOID',
            placeId: this.parkingFine.place.id,
            paidAmount: this.parkingFine.paidAmount,
            paymentDate: this.parkingFine.paymentDate,
            comments: this.comments
          })
          this.close()
        }
      })
    },
    close() {
      this.show = false
    }
  }
}
</script>
